var _style, _path, _polygon, _polygon2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNarrowRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EA0029;}\r\n\t.st1{fill:#FFCD00;}\r\n\t.st2{fill:#1D1D1B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.5,10.8L5.8,60.5c-1,1.7-1,3.8,0,5.5c1,1.7,2.8,2.8,4.8,2.8H68c2,0,3.8-1.1,4.8-2.8c1-1.7,1-3.8,0-5.5 L44.1,10.8c-1-1.7-2.8-2.8-4.8-2.8C37.3,8.1,35.5,9.1,34.5,10.8z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "66.5,62.4 12.1,62.4 39.3,15.3 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "32.1,60.3 32.1,50.9 37.6,44.1 37.6,33.9 32.1,33.9 32.1,42.4 27,49.2 27,60.3 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "46.5,50.9 41,44.1 41,33.9 46.5,33.9 46.5,42.4 51.6,49.2 51.6,60.3 46.5,60.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarrowRoad);
export default __webpack_public_path__ + "static/media/narrow-road.94f41986a5b977096efd2d22e4be2c17.svg";
export { ForwardRef as ReactComponent };